const translations = {
  "en": {
    "See my plan": "See my plan",
    "You're all set — let's get your plan going.": "You're all set — let's get your plan going."
  },
  "zh-tw": {
    "See my plan": "看看我的計畫",
    "You're all set — let's get your plan going.": "一切就緒——我們開始執行你的計畫吧。"
  }
};

export default translations;
